import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { clearProductTimeout, setProductTimeout } from "@/utils/productTimers";

/** How long the 404 page waits before sending the reader home. */
export const FP404_REDIRECT_MS = 10_000;

const Fp404 = () => {
  const navigate = useNavigate();

  // One timer per mount, cleared on unmount (#12239): without deps and a
  // cleanup, every render queued another navigation home, and one still
  // fired after the reader had left the page.
  useEffect(() => {
    const timer = setProductTimeout(
      () => navigate("/", { replace: true }),
      FP404_REDIRECT_MS
    );
    return () => clearProductTimeout(timer);
  }, [navigate]);

  const style = `
    .page_404 {
      padding: 40px 0;
      background: #fff;
    }
    .four_zero_four_bg {
      background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
      height: 600px;
      width: 800px;
      background-repeat: no-repeat;
    }
    .four_zero_four_bg h1 {
      font-size: 80px;
    }
    .link_404 {
      color: #fff !important;
      padding: 10px 20px;
      display: inline-block;
    }
    .contant_box_404 {
      margin-top: -150px;
    }
  `;

  return (
    <div className="h-full w-full flex justify-center items-center bg-white">
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <section className="page_404">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 ">
              <div className="col-sm-10 col-sm-offset-1 text-center">
                <div className="four_zero_four_bg ">
                  <h1 className="text-center ">404</h1>
                </div>
                <div className="contant_box_404">
                  <p>Page not Found!</p>
                  <Link
                    to="/"
                    className="link_404 bg-fp-primary rounded-md shadow-md mt-4"
                  >
                    Go to Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Fp404;
